import React, { useState } from 'react';
import * as PropTypes from "prop-types";
import styles from "./style.module.css";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import {
  injectStripe,
  CardElement,
} from 'react-stripe-elements';

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '18px',
        color: '#212121',
        '::placeholder': {
          color: '#808080',
        },
      },
      invalid: {
        color: '#e1292d',
      },
    },
  };
};

const _StripeForm = React.memo((props) => {
  const [ error, setError ] = useState(undefined);

  const { closeModal, open, modalLoading, setModalLoading } = props;

  const handleChange = () => {
    setError(undefined);
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();
    setModalLoading(true);
    const cardElement = props.elements.getElement('card');
    if (props.stripe) {
      props.stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      })
        .then((payload) => {
          if (payload.error) {
            setModalLoading(false);
            setError(payload.error.message)
          } else {
            props.stripeTokenHandler(payload.paymentMethod);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      console.error("Stripe.js hasn't loaded yet.");
    }
  };

  return (
    <Dialog PaperProps={{ className: styles.container }} open={open} onClose={closeModal}>
      <DialogTitle id="form-dialog-title">
        <div className={styles.formTitle}>
          Add credit or debit card
        </div>
      </DialogTitle>
      <DialogContent>
        <form>
          <div className={styles.formField}>
            <label>
              <span className={styles.formFieldLabel}>Card number</span>
                <CardElement
                  onChange={handleChange}
                  {...createOptions}
                />
            </label>
          </div>
        </form>
        <div className={styles.formError}>
          {error}
        </div>
      </DialogContent>
      <DialogActions>
        <div className={styles.formButtonBlock}>
          <Button type='button'
                  variant='outlined'
                  className={styles.formButtonCancel}
                  onClick={closeModal}
                  disabled={modalLoading}
          >
            Cancel
          </Button>
          <Button type='submit'
                  variant='contained'
                  className={styles.formButtonSave}
                  onClick={handleSubmit}
                  disabled={modalLoading}
                  color="primary"
          >
            Save
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
});

_StripeForm.propTypes = {
  closeModal: PropTypes.func,
  open: PropTypes.bool,
  stripeTokenHandler: PropTypes.func.isRequired,
  modalLoading: PropTypes.bool.isRequired,
  setModalLoading: PropTypes.func.isRequired,
};

const StripeForm = injectStripe(_StripeForm);

export default StripeForm;
